/** Clients Route */
const CLIENTS = {
  CREATE: 'api/v3/clients.json',
  LIST: 'api/v3/clients',
  DETAILS: (clientId) => `api/v3/clients/${clientId}.json`,

  INITIAL_BALANCE: (clientId) =>
    `api/v3/clients/${clientId}/initial_balance.json`,
  BALANCE: (clientId) => `api/v3/clients/${clientId}/balance.json`,
  REGULARIZE_BALANCE: (clientId) => `api/v3/clients/${clientId}/regularization`,
  TREASURY_MOVEMENT: (clientId) =>
    `api/v3/clients/${clientId}/treasury_movements.json`,

  CHECKING_ACCOUNT_EMAIL: (clientId) =>
    `api/v3/clients/${clientId}/send_open_account_link_mail.json`,
  BANK_ACCOUNT_INFO: (token) => `api/v3/billings/${token}/account_info`,
};
Object.freeze(CLIENTS);

/** Sequences Route */
const SEQUENCES = {
  DEFAULT: 'api/v3/sequences',
  CURRENT: 'api/v3/sequences/default',
  REGISTERED_SERIES: 'api/v3/sequences/registered_series.json',
};
Object.freeze(SEQUENCES);

/** Notifications Route */
const NOTIFICATIONS = {
  TEMPLATES: (type) => `api/v3/notification_configurations/${type}/search.json`,
  BILLING_ALERTS: 'api/v3/billing_alerts',
};
Object.freeze(NOTIFICATIONS);

const SIGNATURE_PROVIDER = {
  DEFAULT: 'api/v3/digital_signatures/providers.json',
  BY_ACCOUNT: 'api/v3/digital_signatures/accounts/providers.json',
  CREDENTIALS: 'api/v3/digital_signatures/accounts/credentials.json',
  TOKEN: 'digital_signature/decode_hash',
  INFO: 'api/digital_signature/info.json',
  RENEW: 'digital_signature/renew_digital_signature.json',
};
Object.freeze(SIGNATURE_PROVIDER);
/** Plugins Route */
const PLUGINS = {
  DEFAULT: `api/v3/plugins`,
  BY_ACCOUNT: `api/v3/accounts/plugins`,
};
Object.freeze(PLUGINS);

/** Integrations Route */
const PLUGIN_INTEGRATIONS = {
  DEFAULT: 'api/v3/accounts/integrations',
  STATUS: (id) => `api/v3/accounts/integrations/${id}/toggle_status`,
};
Object.freeze(PLUGIN_INTEGRATIONS);

/** Application Settings Route */
const SETTINGS = {
  TAX_LIST: 'api/v3/taxes',
  ITEMS_LIST: 'api/v3/items',
  CURRENCIES: 'api/v3/currencies',
  PHONE_LIST: 'api/v3/phone_calling_codes',
  ACCOUNT_BALANCE_DETAILS: 'api/v3/accounts/balance',
  EXPORT_DATA: 'api/v3/accounts/export',
  MESSAGE_TEMPLATES: 'api/v3/message_templates',
  TAXES: 'api/v3/taxes',
  AT_COMMUNICATION_SETUP: 'api/v3/accounts/at_communication',
  AT_COMMUNICATION_HISTORY: 'api/v3/accounts/at_communication_history',
};
Object.freeze(SETTINGS);

const CHECKOUT = {
  PLANS: 'api/v3/plans',
  FEATURES: 'api/v3/features',
  ORDER_SUMMARY: 'api/v3/orders/summary',
  PAYMENTS: 'services/v1/easypay/payments',
  SUBSCRIPTION: 'services/v1/easypay/payments/subscription',
  METHOD: 'services/v1/easypay/payments/method',
  FREE_PLAN_SETUP: 'api/v3/free_plans',
};

/** Application Users Route */
const USER = {
  API: (userId) => `api/v3/users/${userId}/api_key`,
  DATA: (userId) => `api/v3/users/${userId}`,
  USER_ACCOUNTS: (userId) => `api/v3/users/${userId}/accounts`,
  CHANGE_CURRENT_ACCOUNT: (userId) =>
    `api/v3/users/${userId}/change_current_account`,
};
Object.freeze(USER);

/** Auths Route */
const AUTHENTICATION = {
  LOGIN: 'api/v3/auth/authenticate',
  RECOVER_PASSWORD: 'api/v3/users/recover_password.json',
  RESET_PASSWORD: 'api/v3/users/reset_password.json',
  SESSION: 'sessions',
  TWO_FACTOR_AUTHENTICATION: (userId) =>
    `api/v3/two_factors/${userId}/authenticate.json`,
  TWO_FACTOR_AUTHENTICATION_EMAIL: (userId) =>
    `api/v3/two_factors/${userId}/resend.json`,
};
Object.freeze(AUTHENTICATION);

/** Users Route */
const ACCOUNT_USERS = {
  LIST: 'api/v3/accounts/users',
  EDIT: (userId) => `api/v3/accounts/users/${userId}`,
  CREATE: `api/v3/accounts/users`,
};
Object.freeze(ACCOUNT_USERS);

/** Application Settings Route */
const FISCAL_CONFIGURATION = {
  ACCOUNT: 'api/v3/accounts',
  NIF_VALIDATION: 'api/v3/vat_numbers/lookup',
  BILLING_HISTORY: 'api/v3/accounts/billing_history',
};
Object.freeze(FISCAL_CONFIGURATION);

/** Application SAF-T Routes */
const SAFT = {
  EXPORT: 'api/v3/saft/export',
  SCHEDULE: 'api/v3/saft/schedules',
  GET_YEARS: 'api/v3/accounts/years_documents',
};
Object.freeze(SAFT);

const SUBSCRIPTION = {
  DETAILS: 'api/v3/accounts/subscription',
};
Object.freeze(SAFT);

export const ENDPOINTS = {
  CLIENTS,
  SEQUENCES,
  NOTIFICATIONS,
  SIGNATURE_PROVIDER,
  PLUGINS,
  PLUGIN_INTEGRATIONS,

  SETTINGS,
  USER,
  AUTHENTICATION,
  ACCOUNT_USERS,
  FISCAL_CONFIGURATION,
  SAFT,
  SUBSCRIPTION,
  CHECKOUT,
};
